<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span
          i.fa-solid.fa-shop
      h1 Azucar del pueblo
    
    .row.justify-content-center
      .col-12
        figure
          img(src='@/assets/curso/azucarPueblo/map.png', alt='').m-auto            
    
    p.p-4.bg-1 Tu destino para una dulce tentación. Disfruta de nuestra selección de cheesecakes, galletas artesanales, café y una amplia variedad de bebidas.

    .row.justify-content-center.align-items-center
      .col-sm-auto.text-center
        a.boton.color-acento-botones(href="https://www.google.com/maps/place/Salento,+Quind%C3%ADo/@4.637365,-75.5703107,3a,75y,90t/data=!3m11!1e2!3m9!1sCIHM0ogKEICAgID6ir3LiwE!2e10!3e12!6shttps:%2F%2Flh3.googleusercontent.com%2Fgps-cs-s%2FAC9h4nrU4bTFIUxtAtcGJmCEyZsuQVWM_EmL5pXv_Rv5qsoQKNbN9pZlTnkIwh8KSM6L0RGvF8tbnFmFksjqBos4MbPzLQGvQrLzMuaHCFcEW9kwAkEiwu742WtbpqT8KmCLehGTQ1KFAg%3Dw203-h270-k-no!7i3000!8i4000!9m2!1b1!2i44!4m7!3m6!1s0x8e388db58fdb7389:0x279e1388933e2000!8m2!3d4.637365!4d-75.5703107!10e5!16zL20vMDh0am5z?entry=ttu&g_ep=EgoyMDI1MDUxMy4xIKXMDSoASAFQAw%3D%3D" target="_blank")
          span.text-black Clic para ver ubicacion
          i.fa-solid.fa-location-dot.text-black

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 Postres

    p #[b Conoce los mejores cheesecakes artesanales del Quindío]
    p Elaborados con ingredientes frescos y mucho amor, nuestros cheesecakes combinan tradición y sabor en cada bocado. Déjate tentar por una experiencia única y auténtica del corazón del Eje Cafetero.

    .tarjeta.tarjeta--azul.p-4
      SlyderA(tipo="b")

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-6
            figure
              img(src='@/assets/curso/azucarPueblo/img1.png', alt='')

          .col-md-6.mb-4.mb-md-0.mt-4
            h4 Cheescake Asado
            p Delicioso cheesecake horneado al estilo tradicional, con una textura cremosa y un toque dorado en la superficie. Su base crujiente y su sabor suave lo convierten en el postre perfecto para cerrar con broche de oro cualquier comida.
            P #[b $12.000]

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-6
            figure
              img(src='@/assets/curso/azucarPueblo/img2.png', alt='')

          .col-md-6.mb-4.mb-md-0.mt-4
            h4 Cheescake de Maracuya
            p Suave y cremoso cheesecake con una base crocante, cubierto con una irresistible capa de maracuyá natural que aporta el equilibrio perfecto entre dulzura y acidez. Refrescante, ligero y lleno de sabor tropical.
            P #[b $12.000]

        .row.justify-content-center.align-items-center.my-lg-4
          .col-md-6
            figure
              img(src='@/assets/curso/azucarPueblo/img3.png', alt='')

          .col-md-6.mb-4.mb-md-0.mt-4
            h4 Cheescake de Frutos Rojos
            p Delicado y cremoso cheesecake con base de galleta, cubierto con una mezcla de frutos rojos (fresas, arándanos y frambuesas) que le dan un toque ácido y dulce a la vez. Perfecto para los amantes de los sabores intensos y frescos.
            P #[b $12.000]


    separador
    #t_1_2.titulo-segundo.color-acento-contenido
      h2 Galletas

    p #[b Galletas artesanales con sabor único]
    p Descubre nuestras irresistibles galletas artesanales, horneadas con ingredientes de alta calidad y un toque creativo en cada receta. Desde los clásicos sabores con chocolate hasta combinaciones sorprendentes como Quipitos y Oreo, cada galleta está hecha para brindarte una experiencia deliciosa y diferente. Perfectas para acompañar tu bebida favorita o disfrutar en cualquier momento del día.

    TabsA.color-acento-botones.mb-5

      .tarjeta.color-acento-botones--borde.p-4(titulo="Galleta Hershey's")
        p Una deliciosa galleta artesanal con trozos del clásico chocolate Hershey’s. Crujiente por fuera, suave por dentro y con ese sabor irresistible que encanta a todos los amantes del chocolate.
        P #[b Precio: $4.000]

        figure
          img(src='@/assets/curso/azucarPueblo/img4.png', alt='')

      .tarjeta.color-acento-botones--borde.p-4(titulo="Galleta Oreo")
        p Galleta artesanal con trozos de galleta Oreo, perfecta para los fanáticos de esta icónica combinación de cacao y crema. Su textura suave y sabor único la convierten en un antojo irresistible.
        P #[b Precio: $4.000]

        figure
          img(src='@/assets/curso/azucarPueblo/img5.png', alt='')


      .tarjeta.color-acento-botones--borde.p-4(titulo="Galleta Quipitos")
        p Deliciosa galleta artesanal con trozos de chocolate y el toque divertido de Quipitos, que explotan en tu boca con cada mordida. Una experiencia dulce, crujiente y explosiva que te encantará.

        figure
          img(src='@/assets/curso/azucarPueblo/img6.png', alt='')


 
 
</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
